import { StateService } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { IAccount } from "@gtmhub/core";
import { DomainService } from "@webapp/accounts/services/domain/domain.service";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";

@Component({
  selector: "account-marketing-info-screen",
  templateUrl: "./account-marketing-info-screen.component.html",
  styleUrls: ["./account-marketing-info-screen.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMarketingInfoScreenComponent implements OnInit {
  constructor(private domainService: DomainService, private featureTogglesFacade: FeatureTogglesFacade, private state: StateService) {}

  public ngOnInit(): void {
    this.featureTogglesFacade.isFeatureAvailable$(FeatureFlag.AccountMarketingInfo).subscribe((isAvailable) => {
      if (!isAvailable) {
        const defaultState = "default";

        this.state.go(defaultState, null, { location: "replace" });
      }
    });
  }

  public onAccountUpdated(account: IAccount): void {
    const domain = this.domainService.constructGtmhubDomain(account.domain);

    window.open(`${location.protocol}//${domain}/`, "_self");
  }
}
